<template>

  <!-- Vendor Video Content -->
  <div
    class="vendor-video-content">

    <!-- Player -->
    <div
      class="vendor-video-content__player">

      <!-- Video -->
      <video-player
        :key="videoLink"
        @click="interact"
        :poster="imageLink"
        :source="videoLink"
        class="vendor-video-content__video"/>

      <!-- Navigator -->
      <div
        class="vendor-video-content__navigator">

        <div
          ref="slides"
          class="vendor-video-content__slides scroll_grey">

          <div
            :key="index"
            @click="select(index)"
            v-for="(item, index) in items"
            class="vendor-video-content__slide cursor-pointer">

            <q-img
              :ratio="16/9"
              class="vendor-video-content__image"
              :src="$u.getFileUrl(item.image, 400)"
              placeholder-src="/images/placeholder/image.png">

              <!--

              <div
                class="full-height full-width q-pa-sm row items-end">

                <span
                  class="text-body2 text-white text-weight-bold">
                  {{ $u.localize(item.title) }}
                </span>

              </div>

              -->

            </q-img>

          </div>

        </div>

      </div>

    </div>

    <!-- Info -->
    <div
      class="vendor-video-content__info">

      <h3
        class="text-weight-bold q-mb-none">
        {{ $u.localize(current.title) }}
      </h3>

      <div
        class="q-mt-sm"
        v-if="hasSpacer"/>

      <div>
        {{ $u.localize(current.description) }}
      </div>

    </div>

  </div>

</template>

<script>

  import {mapState, mapActions} from 'vuex';
  import VideoPlayer from '@src/components/player/video-player';

  export default {
    name: 'vendor-video-content',
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      VideoPlayer,
    },
    data() {
      return {
        index: 0,
        interacted: false,
      };
    },
    computed: {
      ...mapState('vlVendors', {
        vendor: 'item',
      }),
      current() {

        return this.items[this.index];
      },
      videoLink() {

        if (!this.current)
          return;

        return this.current.useLink
          ? this.current.link
          : this.$u.getFileUrl(this.current.file);
      },
      imageLink() {

        if (!this.current)
          return;

        return this.$u.getFileUrl(
          this.current.image,
          1200,
        );
      },
      hasSpacer() {

        return this.$u.localize(
          this.current.title,
        ) && this.$u.localize(
          this.current.description,
        );
      },
    },
    methods: {
      ...mapActions('session', {
        addScore: 'ADD_SCORE',
      }),
      ...mapActions('vlVendors', {
        addViewOf: 'ADD_VIEW_OF',
      }),
      select(index) {

        this.index = index;
        this.interacted = false;
      },
      interact() {

        if (this.interacted)
          return;

        this.interacted = true;

        // Add Score.

        // this.addScore({
        //   referenceId: this.current.id,
        //   referenceType: 'material',
        //   vendorId: this.vendor.id,
        //   name: 'view-vendor-video',
        // });

        // Add View.

        // this.addViewOf({
        //   id: this.current.id,
        //   field: 'videos',
        // });
      },
    },
    mounted() {

      const list = this
        .$refs
        .slides;

      list.addEventListener('wheel', (e) => {

        e.preventDefault();
        list.scrollTop += e.deltaY;
        list.scrollLeft += e.deltaY;
      });
    },
  };

</script>

<style lang="scss">

  .vendor-video-content {

    &__player {
      display: flex;
    }

    &__info {
      width: 73%;
      padding-top: $ibs-y;
    }

    &__video {
      flex-basis: 100%;
    }

    &__navigator {
      flex-shrink: 0;
      flex-basis: 27%;
      position: relative;
      background-color: rgba(155, 155, 155, .1);
    }

    &__slides {
      width: 100%;
      height: 100%;
      overflow: auto;
      position: absolute;
    }

    &__slide {
      width: 100%;
      height: 33.3%;
    }

    &__image {
      height: 100%;
    }

    @media (max-width: $breakpoint-sm) {

      &__player {
        flex-direction: column;
      }

      &__navigator {
        width: 100%;
        height: auto;
      }

      &__slides {
        position: static;
        white-space: nowrap;
      }

      &__slide {
        width: 50%;
        height: auto;
        display: inline-block;
      }
    }
  }

</style>
